import { configUiMenu_mobile_vertical as  configUiMenu_default} from "src/library/minigame_client/ui/menu"

export let configUiMenu_desktop_horizontal = _.cloneDeep(configUiMenu_default);

const resourcesUiMenu_desktop_horizontal = {
    //sounds are loaded separately with super-mega-polished library which handles many different browsers starting even on loading stage:
    howler :
        [
            "res/common/minigames/sounds/btn_click",
        ],
    //all other different resources (even those which configure the game logic) are able to be loaded with PIXI native loader:
    pixi :
        [
            "res/desktop_horizontal/menu/common.json",
            {name: "res/desktop_horizontal/menu/menu.json", rus: true},
        ]
};

configUiMenu_desktop_horizontal.resources = resourcesUiMenu_desktop_horizontal;
configUiMenu_desktop_horizontal.packFolder = "menu_desktop_horizontal/";
configUiMenu_desktop_horizontal.sndBtnClick = "res/sounds/btn_click";
configUiMenu_desktop_horizontal.buttonHelpPosition =     {x: 1633, y: 0};
configUiMenu_desktop_horizontal.buttonSettingsPosition = {x: 1711, y: 0};
configUiMenu_desktop_horizontal.buttonAutoOnPosition =   {x: 1406, y: 570};
configUiMenu_desktop_horizontal.buttonAutoOffPosition =  {x: 1406, y: 570};
configUiMenu_desktop_horizontal.buttonExitPosition =     {x: 16, y: 22};
configUiMenu_desktop_horizontal.buttonSoundOnPosition =  {x: 74, y: 26};
configUiMenu_desktop_horizontal.buttonSoundOffPosition = {x: 74, y: 26};


//////////////////
// WEBPACK FOOTER
// ./cfg/desktop_horizontal/menu.es6
// module id = 38
// module chunks = 0